import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import { Link } from 'gatsby';
import Slider from "react-slick"
import "../../sass/slick/slick.min.scss"
import "../../sass/slick/slick-theme.min.scss"
import TabbedContentAppHub from './tabbedContentAppHub';
import arrowIcon from '../../images/arrow-slider-left-blue.svg';
import textLinkArrow from "../../images/arrow-right-blue-textlink.svg";

const ApphubInteractiveTourModule = ({ data, postObject }) => {

    const [tabVar, setTabVar] = useState('one');

    const tabSwitch = (val) => {
        setTabVar(val);
    }

    const [isRendered, setIsRendered] = useState(false)

    let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        arrows: true,
        touchThreshold: 250
    }

    useEffect(() => {
        setIsRendered(true)
    }, []);

    return (
        <div className="cp-interactiveTour l--app" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-interactiveTour__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                <div className="l--flex">
                    {data.tabbedLayoutCheck === 'partner' ?
                        <>
                            {data.additionalResourcesRightSectionMainLogo ?
                                <>
                                    <div className="cp-logoseperation">
                                        {data.apphubInteractiveTourHeader &&
                                            <h2>{data.apphubInteractiveTourHeader}</h2>
                                        }
                                        {data.apphubInteractiveTourTeaser &&
                                            <div dangerouslySetInnerHTML={{ __html: data.apphubInteractiveTourTeaser }} />
                                        }
                                    </div>
                                    <img loading="lazy" src={data.additionalResourcesRightSectionMainLogo.sourceUrl} alt={data.additionalResourcesRightSectionMainLogo.altText} />
                                </>
                                :
                                <>
                                    {data.apphubInteractiveTourHeader &&
                                        <h2>{data.apphubInteractiveTourHeader}</h2>
                                    }
                                    {data.apphubInteractiveTourTeaser &&
                                        <div dangerouslySetInnerHTML={{ __html: data.apphubInteractiveTourTeaser }} />
                                    }
                                </>
                            }
                        </>
                        :
                        <>
                            {data.apphubInteractiveTourHeader &&
                                <h2>{data.apphubInteractiveTourHeader}</h2>
                            }
                            {data.apphubInteractiveTourTeaser &&
                                <div dangerouslySetInnerHTML={{ __html: data.apphubInteractiveTourTeaser }} />
                            }
                        </>
                    }
                </div>
                <div className="cp-tabbedSection">
                    <div>
                        <button className={`${tabVar === 'one' ? "l--active" : ""}`} onClick={() => tabSwitch("one")}>Solution Tour</button>
                        {data.additionalResourcesTabContent &&
                            <button className={`${tabVar === 'two' ? "l--active" : ""}`} onClick={() => tabSwitch("two")}>Additional Resources</button>
                        }
                    </div>
                    <div className="cp-backButton">
                        {process.env.GATSBY_LANG === "de" ?
                            <a href={`/de/solution-hub/${postObject[0].node.slug}`} className="l--textLink l--flex">
                                <img loading="lazy" src={arrowIcon} />
                                <span>Zurück zur Übersicht</span>
                            </a>
                            :
                            <a href={`/solution-hub/${postObject[0].node.slug}`} className="l--textLink l--flex">
                                <img loading="lazy" src={arrowIcon} />
                                <span>Back to Overview</span>
                            </a>
                        }
                    </div>
                </div>
                {tabVar === 'one' ?
                    <>
                        {data.apphubInteractiveTourIframeField ?
                            <>
                                <div className="cp-interactiveTour__inner-iframe" dangerouslySetInnerHTML={{ __html: data.apphubInteractiveTourIframeField }} />
                                {data.additionalResourcesRelatedResources &&
                                    <div class="cp-tabbedContentAppHub" style={{ backgroundColor: `#fff` }}>
                                        <div className="cp-tabbedContentAppHub__inner">
                                            <div className="cp-tabbedContentAppHub__bottom">
                                                {data.additionalResourcesRelatedResourcesTitle &&
                                                    <h2>{data.additionalResourcesRelatedResourcesTitle}</h2>
                                                }
                                                {data.additionalResourcesRelatedResources &&
                                                    <div className="cp-tabAdditionalresources">
                                                        {data.additionalResourcesRelatedResources.map((gridFields, index) => (
                                                            <React.Fragment key={index}>
                                                                {gridFields.apphubPostFields.apphubLinkInternalOrExternal === 'internal' ?
                                                                    <Link to={`/solution-hub/${gridFields.slug}/`} className={`cp-apphubGridSections__section ${gridFields.apphubPostFields.apphubHeader.includes("overview") ? "l--overviewTile" : ""}`}>
                                                                        {gridFields.apphubPostFields.apphubIllustration ?
                                                                            <GatsbyImage image={getImage(gridFields.apphubPostFields.apphubIllustration.gatsbyImage)} alt={gridFields.apphubPostFields.apphubIllustration.altText} />
                                                                            :
                                                                            <StaticImage src="../../images/apphub-illustration-placeholder-new.png" alt="Apphub" />
                                                                        }
                                                                        <div>
                                                                            {gridFields.apphubPostFields.apphubHeader &&
                                                                                <h3>{gridFields.apphubPostFields.apphubHeader}</h3>
                                                                            }
                                                                            {gridFields.apphubPostFields.apphubTeaser &&
                                                                                <p dangerouslySetInnerHTML={{ __html: gridFields.apphubPostFields.apphubTeaser }} />
                                                                            }
                                                                            <span className="l--flex">
                                                                                {process.env.GATSBY_LANG === "de" ?
                                                                                    <span>Lösung erkunden</span>
                                                                                    :
                                                                                    <span>Explore solution</span>
                                                                                }
                                                                                <img loading="lazy" src={textLinkArrow} alt="" />
                                                                            </span>
                                                                        </div>
                                                                    </Link>
                                                                    :
                                                                    <a href={gridFields.apphubPostFields.apphubExternalLink} target="_blank" className="cp-apphubGridSections__section">
                                                                        {gridFields.apphubPostFields.apphubIllustration ?
                                                                            <GatsbyImage image={getImage(gridFields.apphubPostFields.apphubIllustration.gatsbyImage)} alt={gridFields.apphubPostFields.apphubIllustration.altText} />
                                                                            :
                                                                            <StaticImage src="../../images/apphub-illustration-placeholder.png" alt="Apphub" />
                                                                        }
                                                                        <div>
                                                                            {gridFields.apphubPostFields.apphubHeader &&
                                                                                <h3>{gridFields.apphubPostFields.apphubHeader}</h3>
                                                                            }
                                                                            {gridFields.apphubPostFields.apphubTeaser &&
                                                                                <p dangerouslySetInnerHTML={{ __html: gridFields.apphubPostFields.apphubTeaser }} />
                                                                            }
                                                                            <span className="l--flex">
                                                                                {process.env.GATSBY_LANG === "de" ?
                                                                                    <span>Lösung erkunden</span>
                                                                                    :
                                                                                    <span>Explore solution</span>
                                                                                }
                                                                                <img loading="lazy" src={textLinkArrow} alt="" />
                                                                            </span>
                                                                        </div>
                                                                    </a>
                                                                }
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                            :
                            <>
                                <div className="cp-tabbedCarouselFlex l--flex">
                                    {data.additionalResourcesTabImageCarousel &&
                                        <div className="cp-tabbedContentAppHub__top-imageCarousel">
                                            {isRendered && (
                                                <Slider {...settings}>
                                                    {data.additionalResourcesTabImageCarousel.map((image, index) => (
                                                        <div className="l--imageSection">
                                                            <GatsbyImage image={getImage(image.gatsbyImage)} alt={image.altText} key={index} />
                                                            {image.caption &&
                                                                <div className="l--caption" dangerouslySetInnerHTML={{ __html: image.caption }} />
                                                            }
                                                        </div>
                                                    ))}
                                                </Slider>
                                            )}
                                        </div>
                                    }
                                    {data.additionalResourcesRightSectionRepeater &&
                                        <div className="cp-tabbedContentAppHub__top-right">
                                            {data.additionalResourcesRightSectionMainHeader &&
                                                <h3>{data.additionalResourcesRightSectionMainHeader}</h3>
                                            }
                                            {data.additionalResourcesRightSectionMainLogo &&
                                                <img loading="lazy" src={data.additionalResourcesRightSectionMainLogo.sourceUrl} alt={data.additionalResourcesRightSectionMainLogo.altText} />
                                            }
                                            {data.additionalResourcesRightSectionRepeater &&
                                                <div className="l--topicsContent">
                                                    {data.additionalResourcesRightSectionRepeater.map((content, index) => (
                                                        <div className="l--topicsContent__section" key={index}>
                                                            {content.title &&
                                                                <h4>{content.title}</h4>
                                                            }
                                                            {content.teaser &&
                                                                <span dangerouslySetInnerHTML={{ __html: content.teaser }} />
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                {data.additionalResourcesRelatedResources &&
                                    <div class="cp-tabbedContentAppHub" style={{ backgroundColor: `#fff` }}>
                                        <div className="cp-tabbedContentAppHub__inner">
                                            <div className="cp-tabbedContentAppHub__bottom">
                                                {data.additionalResourcesRelatedResourcesTitle &&
                                                    <h2>{data.additionalResourcesRelatedResourcesTitle}</h2>
                                                }
                                                {data.additionalResourcesRelatedResources &&
                                                    <div className="cp-tabAdditionalresources">
                                                        {data.additionalResourcesRelatedResources.map((gridFields, index) => (
                                                            <React.Fragment key={index}>
                                                                {gridFields.apphubPostFields.apphubLinkInternalOrExternal === 'internal' ?
                                                                    <Link to={`/solution-hub/${gridFields.slug}/`} className={`cp-apphubGridSections__section ${gridFields.apphubPostFields.apphubHeader.includes("overview") ? "l--overviewTile" : ""}`}>
                                                                        {gridFields.apphubPostFields.apphubIllustration ?
                                                                            <GatsbyImage image={getImage(gridFields.apphubPostFields.apphubIllustration.gatsbyImage)} alt={gridFields.apphubPostFields.apphubIllustration.altText} />
                                                                            :
                                                                            <StaticImage src="../../images/apphub-illustration-placeholder-new.png" alt="Apphub" />
                                                                        }
                                                                        <div>
                                                                            {gridFields.apphubPostFields.apphubHeader &&
                                                                                <h3>{gridFields.apphubPostFields.apphubHeader}</h3>
                                                                            }
                                                                            {gridFields.apphubPostFields.apphubTeaser &&
                                                                                <p dangerouslySetInnerHTML={{ __html: gridFields.apphubPostFields.apphubTeaser }} />
                                                                            }
                                                                            <span className="l--flex">
                                                                                {process.env.GATSBY_LANG === "de" ?
                                                                                    <span>Lösung erkunden</span>
                                                                                    :
                                                                                    <span>Explore solution</span>
                                                                                }
                                                                                <img loading="lazy" src={textLinkArrow} alt="" />
                                                                            </span>
                                                                        </div>
                                                                    </Link>
                                                                    :
                                                                    <a href={gridFields.apphubPostFields.apphubExternalLink} target="_blank" className="cp-apphubGridSections__section">
                                                                        {gridFields.apphubPostFields.apphubIllustration ?
                                                                            <GatsbyImage image={getImage(gridFields.apphubPostFields.apphubIllustration.gatsbyImage)} alt={gridFields.apphubPostFields.apphubIllustration.altText} />
                                                                            :
                                                                            <StaticImage src="../../images/apphub-illustration-placeholder.png" alt="Apphub" />
                                                                        }
                                                                        <div>
                                                                            {gridFields.apphubPostFields.apphubHeader &&
                                                                                <h3>{gridFields.apphubPostFields.apphubHeader}</h3>
                                                                            }
                                                                            {gridFields.apphubPostFields.apphubTeaser &&
                                                                                <p dangerouslySetInnerHTML={{ __html: gridFields.apphubPostFields.apphubTeaser }} />
                                                                            }
                                                                            <span className="l--flex">
                                                                                {process.env.GATSBY_LANG === "de" ?
                                                                                    <span>Lösung erkunden</span>
                                                                                    :
                                                                                    <span>Explore solution</span>
                                                                                }
                                                                                <img loading="lazy" src={textLinkArrow} alt="" />
                                                                            </span>
                                                                        </div>
                                                                    </a>
                                                                }
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </>
                    :
                    <>
                        <TabbedContentAppHub postObject={postObject} data={data} />
                    </>
                }
            </div>
        </div>
    );
}

export default ApphubInteractiveTourModule;